// @flow
import React from 'react';
import { FormattedMessage } from 'react-intl';
import {
  Button,
  Stack,
  Typography,
} from '@fortress-technology-solutions/fortress-component-library/Atoms';
import messages from '../messages';

type Props = {
  name: string,
  unitNumber: string,
  goBack: ?Function,
};

const RenewalOfferHeader = ({ name, unitNumber, goBack }: Props) => (
  <Stack
    data-test="generate-renewal-offer-header"
    alignItems="flex-start"
    spacing={0.5}
    sx={{ mb: 2 }}
  >
    {goBack && (
      <Button variant="text" onClick={goBack}>
        <i className="et-chevron-left" />
        &nbsp;
        <FormattedMessage {...messages.goBack} />
      </Button>
    )}
    <Typography variant="titleLarge" component="h1">
      <FormattedMessage {...messages.generateRenewalOffer} />: {name}
    </Typography>
    <Typography variant="bodyMedium" component="p">
      <FormattedMessage {...messages.unitNumber} /> {unitNumber}
    </Typography>
  </Stack>
);

export default RenewalOfferHeader;
